const env = window._env_ || {};

export const SLEDGEHAMMER_BASE_API = env.SLEDGEHAMMER_BASE_API || process.env.SLEDGEHAMMER_BASE_API || "http://localhost:5000";

/** NetSuite account ID per environment (set via REACT_APP_DEPLOY_ENV at build time). */
const NETSUITE_ACCOUNT_BY_ENV = {
  prod: "7158859",
  uat: "7158859-sb2",
  development: "7158859-sb2",
};
const deployEnv = process.env.REACT_APP_DEPLOY_ENV || "development";
export const SLEDGEHAMMER_NETSUITE_ACCOUNT = NETSUITE_ACCOUNT_BY_ENV[deployEnv] ?? NETSUITE_ACCOUNT_BY_ENV.development;